const Hammer = require("hammerjs");
const managers = new Map();

function getHammerInstance(element, options = null) {
	let manager = managers.get(element);

	if (manager == null) {
		manager = new Hammer(element, options);
		managers.set(element, manager);
	}

	return manager;
}

module.exports = getHammerInstance;